import React, {
  Component
} from "react";
import { connect } from "react-redux";

import { sceneData } from "./redux/actions";
import ThreeMain from "./containers/three";
import HomePageC from "./containers/HomePage";

import "./webp-dect";
const { Modernizr } = window;

const CDN_URL = process.env.REACT_APP_CDN_URL

const path = window.location.pathname.split("/");
const urluuid = path[2];

class App extends Component {
  componentDidMount = () => {
    let size = 1024

    fetch(`${CDN_URL}/project-data/${urluuid}.json`)
      .then(res => res.json())
      .then(res => {
        let palyerdata = JSON.parse(res.player_data);
        let categorydata = JSON.parse(res.category_data);

        let mainCategoryData = res.main_category ? JSON.parse(res.main_category) : res.main_category
        let catagorymain = categorydata.map((a) => ({
          catagoryName: a.name,
          SceneID: a.imageuuid,
          thumbnailUrl: a.imagepath
        }));
        palyerdata.map((item, index) => {
          let sceneurl = `${CDN_URL}/cubemaps/${item.sceneId}/${size}`;

          Modernizr.on('webp', function (result) {
            if (result) {
              palyerdata[index].urls = {
                px: `${sceneurl}/px.webp`,
                nx: `${sceneurl}/nx.webp`,
                py: `${sceneurl}/py.webp`,
                ny: `${sceneurl}/ny.webp`,
                pz: `${sceneurl}/pz.webp`,
                nz: `${sceneurl}/nz.webp`,
              }
            } else {
              palyerdata[index].urls = {
                px: `${sceneurl}/px.jpg`,
                nx: `${sceneurl}/nx.jpg`,
                py: `${sceneurl}/py.jpg`,
                ny: `${sceneurl}/ny.jpg`,
                pz: `${sceneurl}/pz.jpg`,
                nz: `${sceneurl}/nz.jpg`,
              }
            }
          });
        })
        catagorymain.map((item, index) => {
          catagorymain[index].thumbnailUrl = `${CDN_URL}/thumbnails/${item.SceneID}`;
        })

        let mainCategory = []
        if (mainCategoryData && mainCategoryData.data) {
          mainCategoryData.data.map((item, index) => {
            let subCategory = []
            item.subCategory.map((a, i) => {
              subCategory[i] = {
                catagoryName: a.name,
                SceneID: a.imageuuid,
                thumbnailUrl: `${CDN_URL}/thumbnails/${a.imageuuid}`
              }
            })
            mainCategory[index] = {
              enableHotspotName: mainCategoryData.enableHotspotNames,
              id: item.id,
              name: item.name,
              subCategory: subCategory
            }
          })
        }

        let main_category = res.main_category ? { data: mainCategory } : res.main_category
        let annotations = res.annotations ? JSON.parse(res.annotations) : res.annotations
        let aerial_data = res.aerial_data ? JSON.parse(res.aerial_data) : res.aerial_data
        let first_scene = res.first_scene ? JSON.parse(res.first_scene) : res.first_scene
        let brand_color = res.brand_color ? res.brand_color : "#ffce01"
        let autoplay = res.autoPlay ? res.autoPlay : false
        let enableLogoInPlayer = res.enableLogoInPlayer === false ? false : true
        let enableLogoInCover = res.enableLogoInCover === false ? false : true
        let contactNumber = palyerdata[0].contactNumber
        let info = {
          creatorName: res.creator,
          companyName: res.title,
          companyLogoUrl: `${CDN_URL}/logos/${res.logo}`,
          bannerImgUrl: `${CDN_URL}/banner/${res.banner}`,
        }
        if (res.creator_logo) {
          info.creatorLogo = `${CDN_URL}/creator-logo/${res.creator_logo}`
        }
        let data = {
          mainCategoryData: main_category,
          annotationData: annotations,
          aerialData: aerial_data,
          sceneItems: palyerdata,
          catagoryData: catagorymain,
          firstScene: first_scene,
          brandColor: brand_color,
          autoplay: autoplay,
          contactNumber,
          info,
          enableLogoInPlayer,
          enableLogoInCover
        };

        document.title = "VR Tour | " + data.info.companyName;

        this.props.scenedataDispatch(data);
      });
  };

  render() {
    const {
      removehome
    } = this.props;
    return (
      <div id="main-id">
        {!removehome && <HomePageC />}
        {removehome && (
          <ThreeMain />
        )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    removehome: state.removeHomeReducer,
    downloaded: state.downloadCompletedIdreducer
  };
}

function mapDispatchToProps(dispatch) {
  return {
    scenedataDispatch: data => dispatch(sceneData(data)),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(App);
